import OfficeBuildingCogIcon from './OfficeBuildingCogIcon';
export default OfficeBuildingCogIcon;
